import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { NavItem } from 'react-bootstrap';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import ProgressBar from '../../../../components/progress-bar';
import FeedbackRequestAutomation from './FeedbackRequestAutomationPage';
import RequiredTVCollectorMappingSetup from '../TruVoiceCollectorsPage/RequiredTVCollectorMappingSetup';
import FeedbackRequestSettingPage from './FeedbackRequestSettingPage';
import FeedbackHistoryPage from './FeedbackHistoryRunPage';
import FeedbackRequestEmailSetting from './AutomationEmailPage';
import UserSettingPage from './UserSettingPage';
import { fetchAllFilters } from '../../FilterActions';
import { fetchEmergencySettings } from '../../../Admin/AdminActions';

class DiscoveryBotPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      emergencySettings: null,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  fetchData() {
    const p1 = this.props.dispatch(fetchAllFilters());
    const p2 = this.props.dispatch(fetchEmergencySettings());

    Promise.all([p1, p2])
      .then(
        ([filtersResults, emergencySettings]) => {
          this.setState({ loading: false, emergencySettings });
        },
      );
  }

  renderWarning() {
    const { emergencySettings } = this.state;
    if (!emergencySettings || !emergencySettings.disabled) {
      return null;
    }
    return (
      <div className="alert alert-danger">
        <p>All Feedback Automations and Reminder Emails are disabled globally by TruSales.</p>
        <p>You can still make changes to all automation groups, but they will not be executed.</p>
      </div>
    );
  }

  render() {
    const { loading, emergencySettings } = this.state;
    if (loading) {
      return (<div className="container"><ProgressBar /></div>);
    }
    const { location: { pathname } } = this.props;

    const showWarning = pathname.indexOf('/setup/feedback-requests/automations') === 0 || 
      pathname.indexOf('/setup/feedback-requests/reminder-emails') === 0 ||
      pathname.indexOf('/setup/feedback-requests/history-run') === 0;


    const comps = [
      {
        uri: 'automations',
        label: 'Automations',
        component: FeedbackRequestAutomation,
      },
      {
        uri: 'reminder-emails',
        type: 'reminder',
        label: 'Reminder Emails',
        title: 'Feedback Request Reminder Emails',
        component: FeedbackRequestEmailSetting,
      },
      {
        uri: 'summary-emails',
        type: 'summary',
        label: 'Summary Emails',
        title: 'Feedback Request Summary Emails',
        component: FeedbackRequestEmailSetting,
      },
      {
        uri: 'alert-emails',
        type: 'alert',
        label: 'Termination Alerts',
        title: 'Feedback Request Termination Alerts',
        component: FeedbackRequestEmailSetting,
      },
      {
        uri: 'exclusion-emails',
        type: 'exclusion',
        label: 'Exclusion Alerts',
        title: 'Feedback Request Opportunity Exclusion Alerts',
        component: FeedbackRequestEmailSetting,
      },
      {
        uri: 'users',
        label: 'Users',
        component: UserSettingPage,
      },
      {
        uri: 'settings',
        label: 'Modify Controls',
        component: FeedbackRequestSettingPage,
      },
      {
        uri: 'history-run',
        label: 'History Run',
        component: showWarning && emergencySettings?.disabled ? null : FeedbackHistoryPage,
      },
      /*
      {
        uri: 'change-logs',
        label: 'Change Logs',
        component: ChangeLogsPage,
      },
      */
    ];


    return (
      <div className="container">
        <Helmet title="Feedback Request Automation | Organization Setup" />
        <RequiredTVCollectorMappingSetup silent allowDisabled allowNoSetup types={['decision']}>
          {(validCollectors, validAvailableCollectors) => (
            <div>
              <div>
                <ul className="nav nav-tabs">
                  {comps.map(comp => (
                    <LinkContainer key={comp.uri} to={`/setup/feedback-requests/${comp.uri}`}>
                      <NavItem>{comp.label}</NavItem>
                    </LinkContainer>
                  ))}
                </ul>
                <p />
              </div>
              {(pathname === '/setup/feedback-requests' && <Redirect to="/setup/feedback-requests/automations" />)}

              {showWarning && this.renderWarning()}
                
              <Switch>
                {comps.map((comp) => {
                  return (
                    <Route
                      key={comp.uri}
                      path={`/setup/feedback-requests/${comp.uri}`}
                      render={(props) => {
                        if (comp.type) {
                          return (
                            <div>
                              <Helmet title={`${comp.title} | Organization Setup`} />
                              <comp.component type={comp.type} emergencySettings={emergencySettings} validCollectors={validAvailableCollectors} {...props} />
                            </div>
                          );
                        } else if (comp.component) {
                          return (<comp.component emergencySettings={emergencySettings} validCollectors={validAvailableCollectors} {...props} />);
                        }
                        return null;
                      }}
                    />
                  );
                })}
              </Switch>
            </div>
          )}
        </RequiredTVCollectorMappingSetup>
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

DiscoveryBotPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
};
DiscoveryBotPage.defaultProps = {
};

export default withRouter(connect(mapStateToProps)(DiscoveryBotPage));
